import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'
import { usePayoutPopupContext } from '../context'
import { Separator } from '../Separator'

type PayoutSummaryProps = {
  label: string
  className?: string
}

const PayoutSummary = ({ label, children, className }: React.PropsWithChildren<PayoutSummaryProps>) => {
  const classes = useStyles()
  const { data } = usePayoutPopupContext()

  if (!data) {
    return null
  }

  return (
    <div className={clsx(classes.summaryWrapper, className)}>
      <Separator className={classes.separator} />
      <div className={classes.container}>
        <div className={classes.summary}>{label}</div>
        <div className={classes.summary}>{children}</div>
      </div>
    </div>
  )
}

export default PayoutSummary

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  separator: {
    marginLeft: 16,
    marginTop: 8,
  },
  summary: {
    paddingLeft: 16,
    paddingBottom: 16,
    paddingTop: 12,
    fontWeight: 700,
    fontSize: '13px',
    lineHeight: '17px',
    letterSpacing: '0.02em',
    color: '#212121',
  },
  summaryWrapper: {
    marginRight: 24,
  },
})
